import { render, staticRenderFns } from "./ManageStaff.vue?vue&type=template&id=5939bd1b&scoped=true&"
import script from "./ManageStaff.vue?vue&type=script&lang=ts&"
export * from "./ManageStaff.vue?vue&type=script&lang=ts&"
import style0 from "./ManageStaff.vue?vue&type=style&index=0&id=5939bd1b&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5939bd1b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VBtn,VCardText,VCardTitle,VCol,VRow,VSwitch})
